export enum WatchlistAction {
  preferences = 'preferences',
  watch = 'watch',
  unwatch = 'unwatch',
  nochange = 'nochange',
}
